GameView   = require("views/base/game")
{ AutoCursorRemoveDraggy }  = require("views/components/draggy")

class GameNextInOrderView extends GameView
  templates:
    default: require("./template")
    statement: require("./components/statement")

  events: ->
    "iostap .play-game": "enterGame"
    "iostap .goto-next": "next"

  serialize: ->
    d = super
    d.falseText = _.hyphenate(d.falseText)
    d.trueText  = _.hyphenate(d.trueText)

    d.displayOrder = [
      { klass: "game-false", text: d.falseText }
      { klass: "game-true",  text: d.trueText }
    ]

    d.displayOrder.reverse() if @options.config().direction is "rtl"

    d

  initializeData: ->
    super

    @game.extra.set("fullscreen", true)
    @game.extra.set("sounds", true)

    @setArray "statements",
      _.filter @options.data.statements, (s) -> s.text

  initializeElements: ->
    super

    @setEl @findOne(".game-true"),  "true"
    @setEl @findOne(".game-false"), "false"

    @draggy = new AutoCursorRemoveDraggy
      el: @findOne(".game-statement")

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

  enterGame: ->
    super

    @draggy.lock()

  startGame: ->
    @game.timer.timestamp = Date.now()
    @answeredCount = 0
    @draggy.unlock()
    @guesses = []

    super

  onDrag: (draggy, isInitial) ->
    return if draggy.el.classList.contains("hidden")

    isRight = @isRight(draggy)
    isLeft  = @isLeft(draggy)

    if @options.config().direction is "rtl"
      @getEl("true").classList.toggle("active", isLeft)
      @getEl("false").classList.toggle("active", isRight)
    else
      @getEl("true").classList.toggle("active", isRight)
      @getEl("false").classList.toggle("active", isLeft)

    @transform draggy.el,
      x: draggy.x
      y: draggy.y / 1.2
      rotate: draggy.x * -draggy.y / 5000
      transition: if isInitial then "all 300ms" else ""

  onDrop: (draggy, isReset) ->
    if isReset
      @transform draggy.el,
        x: draggy.x
        y: draggy.y

    else
      return if draggy.el.classList.contains("hidden")

      isComplete = @didMove(draggy)

      if isComplete
        x = @el.offsetWidth * Math.abs(draggy.x) / draggy.x
        draggy.reset { x, y: draggy.y }

        @transition draggy.el, "all 300ms", true
        draggy.el.classList.add("hidden")

        isCorrect =
          if @options.config().direction is "rtl"
            @isLeft(draggy) is draggy.isTrue
          else
            @isRight(draggy) is draggy.isTrue

        window.setTimeout (=>
          if isCorrect
            @onCorrectAnswer
              score: 1000
              time:  1000
              tally: true

          else
            @onIncorrectAnswer
              time: 1000
              tally: true

          guessQ = draggy.$el.text()
          guessA = if draggy.velocity.dir is "left" then "false" else "true"
          guess = q: guessQ, a: guessA
          @guesses.push guess

          @transition draggy.el, "", true
          draggy.reset()

          @answeredCount += 1

          if @game.timer.get("isDisabled") and @answeredCount is @getArray("statements").length
            @endGame()
            return
          
          @showNext()
        ), 400

      else
        @transition draggy.el, "all 300ms"
        draggy.reset()

  didMove: (draggy) ->
    @isRight(draggy) or @isLeft(draggy)

  isRight: (draggy) ->
    (Math.abs(draggy.velocity.x) > 0.5 and
     draggy.velocity.dir is "right") or
    draggy.x > @el.offsetWidth * 0.33

  isLeft: (draggy) ->
    (Math.abs(draggy.velocity.x) > 0.5 and
     draggy.velocity.dir is "left") or
    draggy.x < -@el.offsetWidth * 0.33

  showNext: ->
    @game.timer.timestamp = Date.now()
    statement = @getRandom "statements"

    @getEl("true").classList.remove("active")
    @getEl("false").classList.remove("active")

    @draggy.el.innerHTML = statement.text
    @draggy.isTrue = statement.true

    @draggy.el.offsetLeft
    @draggy.el.classList.remove("hidden")

  answerDetails: ->
    questions = @options.metadata.questions or []
    return [] unless questions.length > 0

    questionMetadataByContentDict =
      _.indexBy questions, (q) -> q.question.content
    _.chain(@guesses)
      .map ({ q, a }) ->
        if questionMetadataByContentDict[q]
          question: questionMetadataByContentDict[q].question
          answer: _.find questionMetadataByContentDict[q].answers, (a) ->
            a.content.toString() is a
        else
          false
      .filter((g) -> g)
      .value()

module.exports = GameNextInOrderView
